import { useMemo } from "react";

import { TiVoTargetsTable } from "components/elements";
import { getSummary } from "components/elements/TiVoTargetsSummary/utils";
import { useTiVoDeviceData } from "components/form/fields/TiVoTargets";
import {
  Column,
  Row,
  Section,
  Subsection,
  VerticalTabs,
} from "components/layout";
import { TiVoAppVariantVersion } from "hooks/tivoApps";
import { NO_VALUE_PLACEHOLDER } from "src/constants";

import { TEXTS } from "../constants";
import styles from "./ZoomConfigsSection.scss";

export function ZoomConfigsSection({
  zoomConfigurations,
}: {
  zoomConfigurations: TiVoAppVariantVersion["zoomConfigurations"];
}) {
  const { getDeviceLabel } = useTiVoDeviceData();
  const tabNames = useMemo(
    () =>
      zoomConfigurations?.length
        ? zoomConfigurations.map(({ targets }) => {
            return {
              name: getSummary(targets, getDeviceLabel),
              noRemove: true,
            };
          })
        : [],
    [zoomConfigurations, getDeviceLabel]
  );

  if (!tabNames.length) {
    return (
      <Section header={TEXTS.ZOOM_CONFIG.HEADER}>
        <p>{TEXTS.ZOOM_CONFIG.NO_ZOOM_CONFIGS_MESSAGE}</p>
      </Section>
    );
  }

  return (
    <Section header={TEXTS.ZOOM_CONFIG.HEADER}>
      <VerticalTabs
        isAddButtonDisplayed={false}
        tabNames={tabNames}
        dataTestId="zoom-configs-tabs"
      >
        {(tabIndex: number) => {
          const config = zoomConfigurations[tabIndex];
          if (!config) {
            return null;
          }

          return (
            <Row className={styles.zoomConfigContent}>
              <Column>
                <Subsection header={TEXTS.ZOOM_CONFIG.ZOOM_FACTOR_SUBS_HEADER}>
                  {config.zoomFactor || NO_VALUE_PLACEHOLDER}
                </Subsection>
                <Subsection
                  header={TEXTS.ZOOM_CONFIG.ZOOM_FACTOR_RATIO_SUBS_HEADER}
                >
                  {config.zoomFactorRatio || NO_VALUE_PLACEHOLDER}
                </Subsection>
              </Column>
              <Column>
                <TiVoTargetsTable targets={config.targets} />
              </Column>
            </Row>
          );
        }}
      </VerticalTabs>
    </Section>
  );
}
